// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1beW9","col":"Table_col__31dOS","fulfillmentStatus":"Table_fulfillmentStatus__8Npfh","emailCol":"Table_emailCol__dmge-"};